module.exports = __webpack_public_path__ + "img/img.504bb90a.png";